import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Functional HTTP interceptor that logs 401 and 403 errors.
 * Redirect handling is delegated to HttpService.errorCustomHandler
 * to avoid redirect loops with the roleGuard on the root route.
 */
export const extendedInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        console.log('Error_Token_Expired: will be handled by HttpService.errorCustomHandler');
      }
      return throwError(() => error);
    })
  );
};
